/* eslint-disable import/no-cycle */
import Cookies from 'universal-cookie';
import { reactLocalStorage } from '@src/utils/localStorage';
import request from './request';

const cookies = new Cookies();

// 延遲 require 避免循環依賴（store → reducers → services → api）
// eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
const getStore = () => require('@src/store').getClientStore?.();

const getHeader = () => {
	const isJwtToken = reactLocalStorage.get('isJwtToken');
	const jwtEnabled = isJwtToken === true || isJwtToken === 'true';

	// JWT: access_token 存 Redux memory（避免 XSS 讀 localStorage）
	// Session: 兼容 JWT 上線前登入的存量 session token（仍在 localStorage / cookie，過期或登出後自然消失）
	let authorizationToken = '';
	if (jwtEnabled) {
		try {
			authorizationToken = getStore()?.getState().session?.token || '';
		} catch (e) {
			authorizationToken = '';
		}
	} else {
		const cookieToken = cookies.get('token') || '';
		const token = reactLocalStorage.get('token') || '';
		authorizationToken = token || cookieToken;
	}

	const authorization = jwtEnabled ?
		`Bearer ${authorizationToken}` :
		authorizationToken;

	return {
		Authorization: authorization,
	};
};

const delay = (interval, data) => new Promise(resolve => {
	setTimeout(() => {
		resolve(data);
	}, interval);
});

export default {
	get(url, data, otherConfigs) {
		return request('GET', url, data, getHeader(), otherConfigs);
	},
	post(url, data, otherConfigs) {
		return request('POST', url, data, getHeader(), otherConfigs);
	},
	delete(url, data, otherConfigs) {
		return request('DELETE', url, data, getHeader(), otherConfigs);
	},
	put(url, data, otherConfigs) {
		return request('PUT', url, data, getHeader(), otherConfigs);
	},
	upload(url, data, otherConfigs) {
		return request('POST', url, data, getHeader(), otherConfigs);
	},
	patch(url, data, otherConfigs) {
		return request('PATCH', url, data, getHeader(), otherConfigs);
	},
	mock(interval, data) {
		return delay(interval, data);
	},
};
